<template>
    <CqModal
        :showModal="show"
        @closeModal="closeModal"
        heading="Medewerkergegevens"
    >
        <InfoGrid v-if="company && companyEmployee">
            <InfoHeader>Werknemer</InfoHeader><div>{{ companyEmployee.name }}</div>
            <InfoHeader>Mobiel nummer</InfoHeader><div>{{ companyEmployee.phone.length ? companyEmployee.phone : 'Onbekend' }}</div>
            <InfoHeader>E-mailadres</InfoHeader><div>{{ companyEmployee.email.length ? companyEmployee.email : 'Onbekend' }}</div>
            <InfoHeader>Uitzendbureau</InfoHeader><div>{{ company.name }}</div>
        </InfoGrid>
    </CqModal>
</template>

<script lang="ts">
    import {CqModal} from '@cquential/ui';
    import InfoHeader from '@/components/Branding/InfoHeader.vue';
    import InfoGrid from '@/components/Branding/InfoGrid.vue';
    import {Company, CompanyEmployee} from '@cquential/api';
    import {Component, Vue} from 'vue-facing-decorator';

    @Component({
        components: {
            CqModal,
            InfoHeader,
            InfoGrid,
        },
    })
    export default class CompanyEmployeeDetailsModal extends Vue {
        private static instance: CompanyEmployeeDetailsModal | null = null;

        private show: boolean = false;
        private companyEmployee: CompanyEmployee | null = null;
        private company: Company | null = null;

        public mounted(): void {
            CompanyEmployeeDetailsModal.instance = this;
        }

        public beforeUnmount(): void {
            CompanyEmployeeDetailsModal.instance = null;
        }

        public closeModal(): void {
            this.show = false;
        }

        public static open(employee: CompanyEmployee, company: Company): void {
            this.instance!.companyEmployee = employee;
            this.instance!.company = company;
            this.instance!.show = true;
        }
    }
</script>
